<div id="cfs-vb-acc-reg">

    <formly-form [form]="formGroup" [model]="model" [fields]="fields"></formly-form>

</div>